import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import {
  Tooltip, TooltipTrigger, TooltipContent, TooltipProvider,
} from "./ui/tooltip";

const stop = (e) => e.stopPropagation();

// Prompt 19 B1 — info icon with a tooltip on hover + keyboard focus (Esc closes).
export function HelpTip({ text, anchor, testid, label }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label || "More info"}
            onClick={stop}
            data-testid={testid}
            className="inline-flex items-center align-middle ml-1 text-neutral-400 hover:text-neutral-900 focus:outline-none focus-visible:text-neutral-900 focus-visible:ring-1 focus-visible:ring-neutral-900"
          >
            <Info size={12} strokeWidth={2.2} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          onClick={stop}
          className="max-w-xs rounded-none bg-neutral-900 text-white font-sans text-xs leading-snug normal-case tracking-normal text-left"
          data-testid={testid ? `${testid}-content` : undefined}
        >
          <div>{text}</div>
          {anchor && (
            <Link to={`/help#${anchor}`} className="inline-block mt-1.5 underline"
                  data-testid={testid ? `${testid}-learn-more` : undefined}>
              Learn more
            </Link>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

// "?" icon-link straight to a /help section.
export function HelpLink({ anchor, testid, label = "Help" }) {
  return (
    <Link
      to={`/help#${anchor}`}
      onClick={stop}
      aria-label={`${label}: open help`}
      title="Open help"
      data-testid={testid}
      className="inline-flex items-center justify-center shrink-0 w-5 h-5 rounded-full border border-neutral-300 text-[10px] font-semibold font-sans text-neutral-500 align-middle transition-colors hover:border-neutral-900 hover:text-neutral-900 focus:outline-none focus-visible:ring-1 focus-visible:ring-neutral-900"
    >
      ?
    </Link>
  );
}
